module.exports = {"libs.validator.message.required":"必須","libs.validator.message.invalidEmail":"無効なメール","libs.validator.message.invalidPassword":"少なくとも6文字が必要です","libs.validator.message.invalidPassword.redemptionAuth":"パスワードは6文字でなければなりません。 更新してください。","libs.validator.message.invalidDob.format":"無効な形式","libs.validator.message.invalidDob.ageLimit":"あなたは16歳以上でなければなりません","libs.validator.message.invalidZipCode.CA":"郵便番号が無効です","libs.validator.message.invalidZipCode.US":"郵便番号が無効です","libs.validator.message.invalidPhoneNumber":"無効な電話番号"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/libs/validator.json
// module id = 839
// module chunks = 0